/** What the assistant Overview tab's General and Integrations and Knowledge cards show, derived from the agent's setup
 *  (Figma "Overview card state matrix", S0–S8: mailbox × integrations × knowledge). */

export type OverviewNextStep = 'setUpMailbox' | 'addMailbox' | 'addKnowledge' | 'addIntegration';

export interface OverviewSetup {
    hasMailbox: boolean;
    workspaceHasMailbox: boolean;
    canSetUpMailbox: boolean;
    hasIntegrations: boolean;
    hasKnowledge: boolean;
}

export const getOverviewNextStep = ({
    hasMailbox,
    workspaceHasMailbox,
    canSetUpMailbox,
    hasIntegrations,
    hasKnowledge,
}: OverviewSetup): OverviewNextStep | null => {
    if (!hasMailbox && !workspaceHasMailbox) return canSetUpMailbox ? 'setUpMailbox' : null;
    if (!hasIntegrations && !hasKnowledge) return 'addKnowledge';
    if (!hasMailbox) return 'addMailbox';
    if (!hasKnowledge) return 'addKnowledge';
    if (!hasIntegrations) return 'addIntegration';
    return null;
};

/** Integrations: ERP, master data, order history and document creation (the Integrations tab). */
export const getIntegrationKeys = (agent: any): string[] =>
    [
        agent?.erpToolProvider?.key && 'erp',
        agent?.masterDataToolProvider?.channelId && 'masterData',
        agent?.orderHistoryToolProvider?.enabled && 'orderHistory',
        agent?.defaultChannels && 'documentCreation',
    ].filter(Boolean) as string[];

/** Knowledge: everything the assistant reads while working — files, websites, synced sources and expert knowledge. */
export const getKnowledgeKeys = (agent: any): string[] =>
    [
        // synced files (SharePoint, SFTP, websites) are listed under their source instead
        (agent?.knowledgeFiles || []).some((file) => !file.isSynced && file.sourceType !== 'url') && 'files',
        (agent?.knowledgeUrls || []).length > 0 && 'websites',
        agent?.sharepointToolProvider && 'sharepoint',
        agent?.sftpKnowledgeSource && 'sftp',
        (agent?.instructions || []).some((section) => section.body?.trim()) && 'expertKnowledge',
    ].filter(Boolean) as string[];
